import { render, staticRenderFns } from "./home.vue?vue&type=template&id=85217474&scoped=true&"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=85217474&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85217474",
  null
  
)

export default component.exports